import React from 'react';
import { createRoot } from 'react-dom/client';

import { AdaptiveExamCenterSearch } from '../main-app/components/ExamCentersSearch';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-exam-center-search');

  if (!node) return;

  let ads = [];
  try {
    ads = JSON.parse(node.dataset.ads).map(JSON.parse);
  } catch (e) {
    console.warn('Parsing ads failed');
  }

  const root = createRoot(node);
  root.render(<AdaptiveExamCenterSearch {...node.dataset} ads={ads} />);
});
